import React, { Component, Fragment } from "react";

class Content extends Component {
  render() {
    return <Fragment>{this.props.children}</Fragment>;
  }
}

export default Content;
